<template>
  <CardModalLayout>
    <template #card-modal-top>
      <CardModalFloatingHeader target="floating" scrollable-element="window-modal" :card="card" />
    </template>
    <!-- header -->
    <template #card-modal-header>
      <CardHeader class="window" :card="card" data-target="floating" />
      <ModalCloseButton v-if="isMobile" />
    </template>
    <!-- content -->
    <template #card-modal-content>
      <!-- details -->
      <CardModalDetails :card="card" />
      <!-- description -->
      <CardModalDescription class="card-modal__section" :description="card.description" />
      <!-- tasks -->
      <CardModalTasks class="card-modal__section" :tasks="card.checklists" />
      <!-- activity -->
      <CardModalActivity class="card-modal__section" />
    </template>
    <template #card-modal-sidebar>
      <!-- sidebar -->
      <CardModalSidebar v-if="!isMobile" :card="card" />
      <!-- mobile sidebar -->
      <CardModalMobileMenu v-else :card="card" />
    </template>
  </CardModalLayout>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import { scrollToElement } from 'Utils'
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import CardModalLayout from 'Layouts/CardModalLayout'
import CardHeader from '../common/components/CardHeader'
import CardModalTasks from './components/CardModalTasks'
import CardModalDetails from './components/CardModalDetails'
import CardModalSidebar from './components/CardModalSidebar'
import CardModalActivity from './components/CardModalActivity'
import CardModalMobileMenu from './components/CardModalMobileMenu'
import CardModalDescription from './components/CardModalDescription'
import CardModalFloatingHeader from './components/CardModalFloatingHeader'
import ModalCloseButton from 'Modules/Card/common/components/ModalCloseButton'

export default {
  name: 'CardModal',

  components: {
    CardHeader,
    CardModalTasks,
    CardModalLayout,
    CardModalDetails,
    ModalCloseButton,
    CardModalSidebar,
    CardModalActivity,
    CardModalMobileMenu,
    CardModalDescription,
    CardModalFloatingHeader,
  },

  data() {
    return {
      card: null,
    }
  },

  mixins: [MobileBreakpointControl],

  methods: {
    toggleCardUser(e) {
      if (e.code === 'Space' && e.target.id === 'window-modal-wrapper')
        EventBus.$emit('add-card-user', this.$store.state.user.currentUser)
    },
  },

  async mounted() {
    await this.$nextTick() // wait until the card is loaded
    this.$root.modal = this.$el.closest('.window-modal')
    this.$root.modal.style.scrollPaddingTop = '60px'
    // In case of activity hash
    if (this.$route.hash) {
      scrollToElement(this.$route.hash, '#window-modal', 40)
    }
  },

  created() {
    this.card = this.$store.state.cards.currentCard

    // Setting user toggler function with "space" key
    window.addEventListener('keyup', this.toggleCardUser)
  },

  destroyed() {
    window.removeEventListener('keyup', this.toggleCardUser)
  },
}
</script>

<style scoped>
.modal-close-button {
  justify-self: flex-end;
}

.card-modal__section {
  margin-top: 20px;
}

.card-modal__separator {
  margin: 20px -20px 0;
}
</style>
